import { alpha, createTheme } from '@mui/material';
import { grey } from '@mui/material/colors';
import type {} from '@mui/x-data-grid-premium/themeAugmentation';
import commonThemePalette from '../../common/palette';
import commonThemeTypography from '../../common/typography';
import darkPalette from '../../palettes/dark';
import lightPalette from '../../palettes/light';
import { createCustomMuiShadows } from '../../utils';
import MuiAccordion from './styleOverrides/accordion';
import MuiAlert from './styleOverrides/alert';
import MuiAppBar from './styleOverrides/appBar';
import MuiBreadcrumbs from './styleOverrides/breadcrumbs';
import MuiButton from './styleOverrides/button';
import MuiButtonBase from './styleOverrides/buttonBase';
import MuiCheckbox from './styleOverrides/checkbox';
import MuiChip from './styleOverrides/chip';
import MuiDataGrid from './styleOverrides/dataGrid';
import MuiFormControl from './styleOverrides/formControl';
import MuiIconButton from './styleOverrides/iconButton';
import MuiInput from './styleOverrides/input';
import MuiInputLabel from './styleOverrides/inputLabel';
import MuiLink from './styleOverrides/link';
import MuiListItem from './styleOverrides/listItem';
import MuiPaper from './styleOverrides/paper';
import MuiPopover from './styleOverrides/popover';
import MuiSelect from './styleOverrides/select';
import MuiStack from './styleOverrides/stack';
import MuiSvgIcon from './styleOverrides/svgIcon';
import MuiTableCell from './styleOverrides/tableCell';
import MuiTablePagination from './styleOverrides/tablePagination';
import MuiTableRow from './styleOverrides/tableRow';
import MuiToolbar from './styleOverrides/toolbar';
import MuiTypography from './styleOverrides/typography';

export default createTheme({
  colorSchemes: {
    light: {
      palette: {
        ...commonThemePalette,
        ...lightPalette,
        mode: 'light',
      },
    },
    dark: {
      palette: {
        ...commonThemePalette,
        ...darkPalette,
        mode: 'dark',
      },
    },
  },
  cssVariables: {
    nativeColor: true,
    disableCssColorScheme: true,
    colorSchemeSelector: '[data-theme=%s]',
  },
  breakpoints: {
    values: { xs: 0, sm: 600, md: 900, lg: 1320, xl: 1536 },
  },
  shadows: createCustomMuiShadows(alpha(grey[700], 0.2)),
  typography: commonThemeTypography('var(--mui-palette-text-primary)'),
  components: {
    MuiAccordion,
    MuiAlert,
    MuiAppBar,
    MuiBreadcrumbs,
    MuiButton,
    MuiButtonBase,
    MuiCheckbox,
    MuiChip,
    MuiDataGrid,
    MuiIconButton,
    MuiPaper,
    MuiPopover,
    MuiSvgIcon,
    MuiTableCell,
    MuiTablePagination,
    MuiTableRow,
    MuiTypography,
    MuiLink,
    MuiInput,
    MuiInputLabel,
    MuiFormControl,
    MuiSelect,
    MuiStack,
    MuiToolbar,
    MuiListItem,
  },
});
